import { NativeStackNavigationOptions } from "@react-navigation/native-stack";

import VariantForm from "./VariantForm";
import VariantFormHeader from "./VariantFormHeader";
import useProductFormFormik from "../../hooks/useProductFormFormik";
import { StackScreenProps, productFormRoutes } from "../../navigation/types";
import { VariantWithOptions } from "../../types";

type Props = StackScreenProps<typeof productFormRoutes.variantForm>;
export default function VariantFormScreen({ navigation, route }: Props) {
  const selectedVariant = route.params?.selectedVariant;

  const {
    values: {
      variants: { variantsWithOptions },
    },
    saveVariant,
  } = useProductFormFormik();

  const existingVariants = variantsWithOptions.map(({ variant }) => variant);

  const idx = selectedVariant
    ? existingVariants.map((v) => v.name).indexOf(selectedVariant)
    : variantsWithOptions.length;

  const selectedVariantWithOptions =
    variantsWithOptions[idx] || newVariantWithOptions;

  const handleSaveVariant = (variantWithOptions: VariantWithOptions) => {
    saveVariant(variantWithOptions, selectedVariant);

    navigation.goBack();
  };

  return (
    <VariantForm
      variantWithOptions={selectedVariantWithOptions}
      selectedVariant={selectedVariant}
      existingVariants={existingVariants}
      saveVariant={handleSaveVariant}
    />
  );
}

const newVariantWithOptions: VariantWithOptions = {
  variant: { name: "" },
  options: [],
};

export const variantFormScreenOptions: NativeStackNavigationOptions = {
  header: () => <VariantFormHeader />,
};
